import TabsAutomatic from '../../components/tabs';

let size_guide_init = false;

const extractFitFromReviews = () => {
  if ($('[data-reviews-json]').length) {
    const reviews = JSON.parse($('[data-reviews-json]').html());
    const reviews_html = $.parseHTML(reviews);
    // console.log('reviews_html', reviews_html.length, reviews_html[2]);

    if (reviews_html.length < 3) {
      return;
    }

    const fit_html = $(reviews_html[2]).find('[data-title="how-does-it-fit"]');
    if (typeof fit_html === 'undefined' || !fit_html.length) {
      return;
    }

    // console.log('fit_html', fit_html.html());

    $('[data-size-guide-fit]').html(fit_html.html()).addClass('active');
  }
};

const initConversion = () => {
  $(document).on('click touchend', '[data-size-guide-conversion] button', (e) => {
    const $item = $(e.currentTarget);
    const selected_units = $item.data('size-units');
    const unselected_units = selected_units === 'in' ? 'cm' : 'in';

    $('[data-size-guide-conversion] button').removeClass('active');
    $item.addClass('active');
    
    // convertSizes(selected_units);
    $(`.size-guide tbody[data-units="${unselected_units}"]`).addClass('visually-hidden');
    $(`.size-guide tbody[data-units="${selected_units}"]`).removeClass('visually-hidden');
  });
};

export default () => {
  if (document.body.classList.contains('template-page-size-guide')) {
    initConversion();
    return;
  }

  if (size_guide_init) {
    return;
  }

  size_guide_init = true;

  const containerEl = document.getElementById('size-guide-modal');
  const container_name = containerEl ? '#size-guide-modal' : '#size-guide';
  const tablist = document.querySelector(`${container_name} [role=tablist]`);
  if (tablist) {
    new TabsAutomatic(tablist);
  }

  extractFitFromReviews();

  $(document).on('click touchend', '[data-size-guide-tab]', (e) => {
    const $item = $(e.currentTarget);

    $('[data-size-guide-tab]').removeClass('active');
    $item.addClass('active');
  });

  initConversion();
};
